import React from 'react';

export interface FilterOption<T = string | number | 'all'> {
  value: T;
  label: string;
  count?: number;
}

interface Props<T> {
  value: T;
  options: FilterOption<T>[];
  onChange: (value: T) => void;
}

/** Horizontal row of toggle pills used at the top of list tabs. */
export default function FilterPills<T extends string | number>({ value, options, onChange }: Props<T>) {
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
      {options.map(o => {
        const active = o.value === value;
        return (
          <button
            key={String(o.value)}
            type="button"
            onClick={() => onChange(o.value)}
            style={{
              fontFamily: 'var(--font-ui)',
              fontSize: 12, fontWeight: 500,
              padding: '5px 12px',
              borderRadius: 14,
              cursor: 'pointer',
              border: '1px solid ' + (active ? '#0E7490' : '#DDE0E6'),
              background: active ? '#0E7490' : '#fff',
              color: active ? '#fff' : '#5A6272',
              transition: 'all 0.12s',
            }}
          >
            {o.label}
            {o.count != null && (
              <span style={{
                marginLeft: 6,
                fontFamily: 'var(--font-mono)',
                fontSize: 10,
                opacity: 0.85,
              }}>{o.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
